import {
  CREATE_ROLE_STARTED,
  CREATE_ROLE_COMPLETED,
  CREATE_ROLE_FAILED,
  CLEAR_STATES
} from '@/store/types'

function getDefaultState () {
  return {
    loading: false,
    error: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    [CREATE_ROLE_STARTED] (state) {
      state.loading = true
    },
    [CREATE_ROLE_COMPLETED] (state) {
      state.loading = false
      state.error = undefined
    },
    [CREATE_ROLE_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async create ({ commit, dispatch, rootState: { client = undefined } }, roleName) {
      try {
        commit(CREATE_ROLE_STARTED)
        await client.managementClient.createRole(roleName)
        await dispatch('management/rolesList/list', {}, {
          root: true
        })
        commit(CREATE_ROLE_COMPLETED)
      } catch (err) {
        commit(CREATE_ROLE_FAILED, err)
      }
    }
  }
}
